import { Layout, Tooltip } from "antd";
import DrawerMenus from "components/common/drawer-menus";
import Nav from "components/common/nav";
import collapseIcon from "assets/icons/collapse.svg";
import { useState } from "react";
import style from "./style.module.css";
import useBreakpoints from "utils/hooks/useBreakpoints";
import { layoutContainerPadding } from "utils/Constants";
import useFilteredNavMenus from "utils/hooks/useFilteredNavMenus";

const { Header, Content, Sider } = Layout;

const GlobalLayout: React.FC = ({ children }) => {
  const { filteredNavMenus } = useFilteredNavMenus({ isDisplayMenu: true });
  const [collapsed, setCollapsed] = useState(false);
  const { mappedValue: mappedPadding } = useBreakpoints(layoutContainerPadding);

  return (
    <>
      <div id="skip-main-wrap" tabIndex={0}>
        <a className="skip-main" href="#main">
          Skip to main content
        </a>
      </div>
      <Layout style={{ minHeight: "100vh" }}>
        <Header className="global-header">
          <Nav />
        </Header>
        <Layout>
          <Sider
            collapsible={true}
            collapsedWidth={76}
            width={256}
            breakpoint="sm"
            trigger={
              <div className={style["button-container"]}>
                <Tooltip title={collapsed ? "Expand" : "Collapse"} placement="right">
                  <button
                    className={["invisible-btn", style["sider-trigger"]].join(" ")}
                    aria-label="minimise menu"
                  >
                    <img
                      src={collapseIcon}
                      alt="collapse"
                      style={collapsed ? { transform: "rotate(180deg)" } : {}}
                    />
                  </button>
                </Tooltip>
              </div>
            }
            collapsed={collapsed}
            onCollapse={value => setCollapsed(value)}
          >
            <DrawerMenus navItem={filteredNavMenus} isDrawer={false} collapsed={collapsed} />
          </Sider>

          <Content style={mappedPadding} id="main">
            {children}
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default GlobalLayout;
